import * as PopoverPrimitive from '@radix-ui/react-popover'
import { styled } from 'styled-components'

import { surfaceBright, outline } from 'core/styles'

export const Popover = PopoverPrimitive.Root
export const PopoverAnchor = PopoverPrimitive.Anchor
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverContent = styled(PopoverPrimitive.Content)`
  z-index: 10;
  border: 1px solid ${outline};
  border-radius: 8px;
  background-color: ${surfaceBright};
  padding: 16px;
`
export const PopoverClose = PopoverPrimitive.Close
